import React, { useMemo } from 'react';
import { AvFiltersBase, type AvFiltersProps } from './AvFiltersBase';
import { FilterConfig, FilterProvider } from './filters/FilterContext';

const AvFilters: React.FC<AvFiltersProps> = props => {
  const config = useMemo<FilterConfig>(
    () => ({
      size: props.size === 'small' ? 'small' : 'xSmall',
      disabled: props.disabled,
      showAdvanced: props.showAdvanced,
      enableQueryObj: props.enableQueryObj,
      activeProjName: props.activeProjName,
      displayRecommendedFields: props.displayRecommendedFields ?? true,
    }),
    [props.activeProjName, props.disabled, props.displayRecommendedFields, props.enableQueryObj, props.showAdvanced, props.size]
  );

  return (
    <FilterProvider config={config}>
      <AvFiltersBase {...props} />
    </FilterProvider>
  );
};

export default AvFilters;

export { getOptionsByField, getOptionsFromFields, blackListFields } from './AvFilters.utils';
